import { render, staticRenderFns } from "./montorowDatagdt.vue?vue&type=template&id=3bd0fca6&"
import script from "./montorowDatagdt.vue?vue&type=script&lang=js&"
export * from "./montorowDatagdt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd0fca6')) {
      api.createRecord('3bd0fca6', component.options)
    } else {
      api.reload('3bd0fca6', component.options)
    }
    module.hot.accept("./montorowDatagdt.vue?vue&type=template&id=3bd0fca6&", function () {
      api.rerender('3bd0fca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/montorowDatagdt.vue"
export default component.exports